import React from 'react';
import { fx } from '../../fx.js';
import { BODY, MONO, ink } from '../../primitives.js';

const h = React.createElement;

export const TONES = { neutral: ['var(--neu-bg)', 'var(--tx)'], green: ['var(--grn-bg)', 'var(--grn-tx)'], amber: ['var(--amb-bg)', 'var(--amb-tx)'], red: ['var(--red-bg)', 'var(--red-tx)'], blue: ['var(--blu-bg)', 'var(--blu-tx)'], purple: ['var(--pur-bg)', 'var(--pur-tx)'], lime: ['var(--lime)', 'var(--on-accent)'], gold: ['var(--gold)', 'var(--on-accent)'], coral: ['var(--coral)', 'var(--on-accent)'], paper: ['var(--card)', 'var(--tx)'] };

/**
 * Square status tag. `tone` picks by meaning; `small`, `round` (pill); `stamp` renders a Stamp.
 * Replaces CChip, CPill, pillGreen/Amber/Red.
 *
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {'neutral'|'green'|'amber'|'red'|'blue'|'purple'|'lime'|'gold'|'coral'|'paper'} [p.tone]
 * @param {boolean} [p.stamp]
 * @param {boolean} [p.small]
 * @param {boolean} [p.round]
 * @param {React.CSSProperties} [p.style]
 * @param {React.MouseEventHandler} [p.onClick]
 * @param {string} [p.title]
 */
export function Tag({ children, tone = 'neutral', stamp, small, round, style, onClick, title }) {
  const [bg, fg] = TONES[tone] || TONES.neutral;
  const [ang] = React.useState(() => (fx.stampAngle ? fx.stampAngle() : -4));
  if (stamp) return h('span', {
    className: 'mo-pop gx-slam', title, onClick,
    style: {
      '--stamp-r': ang.toFixed(1) + 'deg', position: 'relative', display: 'inline-block', padding: '4px 8px', fontFamily: MONO, fontSize: 'var(--type-stamp)', fontWeight: 700, letterSpacing: 'var(--track-stamp)', lineHeight: 1,
      background: tone === 'neutral' ? 'var(--gold)' : bg, color: tone === 'neutral' || tone === 'lime' || tone === 'gold' || tone === 'coral' ? 'var(--on-accent)' : fg, border: ink(1.5), borderRadius: 'var(--r-stamp)', boxShadow: 'var(--el-stamp)',
      transform: 'rotate(var(--stamp-r, var(--tilt-stamp)))', textTransform: 'uppercase', ...style
    }
  }, children);
  return h('span', {
    title, onClick, className: onClick ? 'hv-chip' : undefined,
    style: {
      display: 'inline-flex', alignItems: 'center', gap: 5, padding: small ? '3px 9px' : '4px 11px', fontFamily: BODY, fontWeight: 700, fontSize: small ? 10.5 : 11.5, lineHeight: 1.2,
      background: bg, color: fg, border: ink(1.5), borderRadius: round ? 20 : small ? 7 : 8, whiteSpace: 'nowrap', ...style
    }
  }, children);
}
